import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { Avatar, AvatarRadii, AvatarSizes } from 'components/Avatar';
import { useTranslation } from 'react-i18next';

interface Props {
  id: string;
  name: string;
  image: string;
  onSelect: (id: string) => void;
  isSelected: boolean;
  isDisabled: boolean;
  claimedUsers?: string[];
  avatarRadius?: AvatarRadii;
}

const ItemRow = forwardRef<HTMLLIElement, Props>(
  (
    {
      name,
      image,
      id,
      onSelect,
      isSelected,
      isDisabled,
      claimedUsers = [],
      avatarRadius = AvatarRadii.Lg
    },
    ref
  ) => {
    const { t } = useTranslation(['common']);
    const handleSelect = () => {
      if (isSelected || !isDisabled) {
        if (claimedUsers?.includes(id)) {
          return;
        }
        onSelect(id);
      }
    };

    return (
      <li
        ref={ref}
        className={classNames(
          'rounded-lg flex p-2 items-center gap-3 cursor-pointer',
          isSelected && 'bg-primary-50',
          isDisabled && 'opacity-50 cursor-not-allowed'
        )}
        onClick={handleSelect}
      >
        <Avatar radius={avatarRadius} src={image} size={AvatarSizes.Lg} />
        <div className="flex-1 flex flex-col items-start justify-center">
          <div className="flex-1 font-bold  text-base">{name}</div>
          {isDisabled && (
            <div className="text-sm text-gray-500">{t('Claimed')}</div>
          )}
        </div>
        <input
          className="mt-1 mr-2"
          type="checkbox"
          checked={isSelected}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onChange={() => {}}
        />
      </li>
    );
  }
);

export default ItemRow;
